import React from "react";
function Purchases() {
  return <></>;
}

export default Purchases;
